import { z } from 'zod';

export const postSupportersClubsResolverSchema = z.object({
    clubs: z.coerce.number().min(1, { message: 'Please select a branch' }),
});
